
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/tv3/marato/faq-espai-entitats",
      function () {
        return require("private-next-pages/corporatiu/tv3/marato/faq-espai-entitats/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/tv3/marato/faq-espai-entitats"])
      });
    }
  